import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { App } from '@app/app';
import { createLoadingAndClearAnimationHandler } from '@app/providers/order-data/loading-animation-handler/loading-animation.handler';

createLoadingAndClearAnimationHandler();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
